$(document).ready(function () {
  $(".banner_slider-sc .slide-list").slick({
    dots: true,
    arrows: false,
    infinite: false,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $(".featured_sc .product-grid").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1601,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1441,
        settings: {
          slidesToShow: 6,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1360,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });

  $(".review_inner").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

   $(".header__inline-menu ul.list-menu.list-menu--inline li").hover(
        function () {
            $(this).find("header-menu").find("details").attr("open", "open"), $(this).find("header-menu").find(".header__submenu").find("details").removeAttr("open");
        },
        function () {
            $(this).find("header-menu").find("details").removeAttr("open");
        });
    $(".header__inline-menu ul.header__submenu li").hover(
        function () {
            $(this).find("details").attr("open", "open");
        },
        function () {
            $(this).find("details").removeAttr("open");
   });

   $(document).on("click", "h3.custom-heading", function(){
    $(this).next().toggle();
     $(this).find("svg").toggleClass("custom-svg-rotate");
   });

  /* pdp page custom product image slider js start */  
  setInterval(function(){
  $(".slider-for-pdp").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav-pdp"
  });
  $(".slider-nav-pdp").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: false,
    asNavFor: ".slider-for-pdp",
    dots: false,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
                {
        breakpoint: 1360,
        settings: {
          vertical: false,
           slidesToShow: 4,
           slidesToScroll: 1
        }
      },
          {
        breakpoint: 1200,
        settings: {
          vertical: false,
           slidesToShow: 3,
           slidesToScroll: 1
        }
      },
      {
        breakpoint: 992,
        settings: {
          vertical: false,
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 575,
        settings: {
          vertical: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
    }, 1000);
  /* pdp page custom product image slider js end */   

   $(document).on('click', '.related-add-to-cart', function(e){
    e.preventDefault();
    
    var id = $(this).attr('data-varid');
    var qty = 1;
    
    var data = {
      "quantity": qty,
      "id": id
    }
    
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(data) {
        window.location = '/cart';
      },
      error:function(data){
        alert(data.responseText);
      }
    });
    
});
  
});

// pdp page tab section
document.addEventListener(
  "DOMContentLoaded",
  function () {
    $("ul.tabs").each(function () {
      var active,
        content,
        links = $(this).find("a");
      active = links.first().addClass("active");
      content = $(active.attr("href"));
      links.not(":first").each(function () {
        $($(this).attr("href")).hide();
      });
      $(this)
        .find("a")
        .click(function (e) {
          active.removeClass("active");
          content.hide();
          active = $(this);
          content = $($(this).attr("href"));
          active.addClass("active");
          content.show();
          return false;
        });
    });
  },
  false
);
